import React from "react";
import { Row } from "react-bootstrap";
import "../../Assets/Styles/pages/landing.scss";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import { InputAdornment } from "@mui/material";

const Banner = ({ setSearhString }) => {
  const { t } = useTranslation();

  return (
    <Row className="m-0 faqBanner py-5 w-100 d-flex justify-content-center ">
      <Row className=" h-50 line_height_100pc text-center d-flex justify-content-center pb-2 align-items-end text_40 productSansBold">
        <p className="m-0 text_40">
          {t("FAQTitle")}
          <span className="mx-2 CenturyGothicB landing_banner_Heading">
            {t("FAQTitlespan")}
          </span>
        </p>
      </Row>
      <Row className="w_32 h-50 d-flex pt-2 w-xs-100">
        <TextField
          onChange={(e) => {
            setSearhString(e.target.value);
          }}
          variant="filled"
          placeholder="Search"
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                sx={{
                  marginTop: "0px !important",
                  display: "flex",
                  alignSelf: "center",
                }}
              >
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiFilledInput-root": {
              borderRadius: "1vw",
              backgroundColor: "rgba(234, 233, 233, 1)",
              border: "none",
            },
            "& .MuiFilledInput-input": {
              paddingTop: "0.5rem",
              paddingBottom: "0.5rem",
              paddingLeft: "0px",
              paddingRight: "0px",
              textAlign: "start",
              color: "rgba(163, 163, 163, 1)",
              fontSize: "0.813rem",
              fontFamily: "productSansLight",
            },
            "& .MuiFilledInput-underline:before": {
              display: "none",
            },
            "& .MuiFilledInput-underline:after": {
              display: "none",
            },
            "& .MuiInputLabel-filled": {
              textAlign: "right",
            },
          }}
        />
      </Row>
    </Row>
  );
};

export default Banner;
